export default __webpack_public_path__ + "static/media/1_Tienda online_1636x1341.32b21f3b.png";